export enum MainAction {
  Tab = 'tab',
  Action = 'action'
}
